var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: !_vm.pageReady,
          expression: "!pageReady",
        },
      ],
      staticClass: "divBox receipt-editor",
    },
    [
      _c(
        "el-card",
        { staticClass: "box-card header-card", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            { staticClass: "page-header" },
            [
              _c(
                "div",
                { staticClass: "header-left" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "back-btn",
                      attrs: { type: "text", icon: "el-icon-arrow-left" },
                      on: { click: _vm.goBack },
                    },
                    [_vm._v("返回")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "header-divider" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "page-title" }, [
                    _vm._v(_vm._s(_vm.pageTitle)),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.saving,
                  },
                  on: { click: _vm.handleSave },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.pageReady
        ? _c(
            "div",
            { staticClass: "main-wrap" },
            [
              _c(
                "el-card",
                {
                  staticClass: "box-card config-panel",
                  attrs: { shadow: "never" },
                },
                [
                  _c(
                    "el-collapse",
                    {
                      staticClass: "config-collapse",
                      model: {
                        value: _vm.activePanels,
                        callback: function ($$v) {
                          _vm.activePanels = $$v
                        },
                        expression: "activePanels",
                      },
                    },
                    [
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "基础信息", name: "base" } },
                        [
                          _c(
                            "el-form",
                            {
                              staticClass: "config-form",
                              attrs: { "label-width": "88px", size: "small" },
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "模板名称" } },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入模板名称" },
                                    model: {
                                      value: _vm.config.templateName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.config,
                                          "templateName",
                                          $$v
                                        )
                                      },
                                      expression: "config.templateName",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "适用场景" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { placeholder: "请选择场景" },
                                      model: {
                                        value: _vm.config.sceneType,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.config, "sceneType", $$v)
                                        },
                                        expression: "config.sceneType",
                                      },
                                    },
                                    _vm._l(_vm.sceneOptions, function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "模板状态" } },
                                [
                                  _c("el-switch", {
                                    model: {
                                      value: _vm.config.active,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.config, "active", $$v)
                                      },
                                      expression: "config.active",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "标题区配置", name: "title" } },
                        [
                          _c(
                            "div",
                            { staticClass: "option-list" },
                            [
                              _c(
                                "div",
                                { staticClass: "switch-line" },
                                [
                                  _c("span", [_vm._v("显示标题")]),
                                  _c("el-switch", {
                                    model: {
                                      value: _vm.config.showTitle,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.config, "showTitle", $$v)
                                      },
                                      expression: "config.showTitle",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.config.showTitle
                                ? _c("el-input", {
                                    staticClass: "option-input",
                                    attrs: {
                                      placeholder: "请输入标题名称",
                                      size: "small",
                                    },
                                    model: {
                                      value: _vm.config.titleText,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.config, "titleText", $$v)
                                      },
                                      expression: "config.titleText",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "switch-line" },
                                [
                                  _c("span", [_vm._v("显示流水单号")]),
                                  _c("el-switch", {
                                    model: {
                                      value: _vm.config.showOrderSequence,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.config,
                                          "showOrderSequence",
                                          $$v
                                        )
                                      },
                                      expression: "config.showOrderSequence",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "switch-line" },
                                [
                                  _c("span", [_vm._v("显示店铺名称")]),
                                  _c("el-switch", {
                                    model: {
                                      value: _vm.config.showStoreName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.config,
                                          "showStoreName",
                                          $$v
                                        )
                                      },
                                      expression: "config.showStoreName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "订单信息区", name: "order" } },
                        [
                          _c("div", { staticClass: "option-list" }, [
                            _c(
                              "div",
                              { staticClass: "switch-line" },
                              [
                                _c("span", [_vm._v("显示送达时间")]),
                                _c("el-switch", {
                                  model: {
                                    value: _vm.config.showDeliveryTime,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.config,
                                        "showDeliveryTime",
                                        $$v
                                      )
                                    },
                                    expression: "config.showDeliveryTime",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "switch-line" },
                              [
                                _c("span", [_vm._v("显示下单时间")]),
                                _c("el-switch", {
                                  model: {
                                    value: _vm.config.showOrderTime,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.config, "showOrderTime", $$v)
                                    },
                                    expression: "config.showOrderTime",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "switch-line" },
                              [
                                _c("span", [_vm._v("显示订单编号")]),
                                _c("el-switch", {
                                  model: {
                                    value: _vm.config.showOrderNumber,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.config,
                                        "showOrderNumber",
                                        $$v
                                      )
                                    },
                                    expression: "config.showOrderNumber",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "switch-line" },
                              [
                                _c("span", [_vm._v("显示备注")]),
                                _c("el-switch", {
                                  model: {
                                    value: _vm.config.showRemark,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.config, "showRemark", $$v)
                                    },
                                    expression: "config.showRemark",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "switch-line" },
                              [
                                _c("span", [_vm._v("显示手机号")]),
                                _c("el-switch", {
                                  model: {
                                    value: _vm.config.showPhone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.config, "showPhone", $$v)
                                    },
                                    expression: "config.showPhone",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.config.showPhone
                              ? _c(
                                  "div",
                                  { staticClass: "switch-line sub" },
                                  [
                                    _c("span", [_vm._v("手机号脱敏")]),
                                    _c("el-switch", {
                                      model: {
                                        value: _vm.config.phoneMask,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.config, "phoneMask", $$v)
                                        },
                                        expression: "config.phoneMask",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "switch-line" },
                              [
                                _c("span", [_vm._v("显示地址")]),
                                _c("el-switch", {
                                  model: {
                                    value: _vm.config.showAddress,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.config, "showAddress", $$v)
                                    },
                                    expression: "config.showAddress",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.config.showAddress
                              ? _c(
                                  "div",
                                  { staticClass: "switch-line sub" },
                                  [
                                    _c("span", [_vm._v("地址脱敏")]),
                                    _c("el-switch", {
                                      model: {
                                        value: _vm.config.addressMask,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config,
                                            "addressMask",
                                            $$v
                                          )
                                        },
                                        expression: "config.addressMask",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "商品列表区", name: "goods" } },
                        [
                          _c("div", { staticClass: "option-list" }, [
                            _c(
                              "div",
                              { staticClass: "switch-line" },
                              [
                                _c("span", [_vm._v("显示商品列表")]),
                                _c("el-switch", {
                                  model: {
                                    value: _vm.config.showGoodsList,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.config, "showGoodsList", $$v)
                                    },
                                    expression: "config.showGoodsList",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "switch-line" },
                              [
                                _c("span", [_vm._v("显示商品条码")]),
                                _c("el-switch", {
                                  model: {
                                    value: _vm.config.showGoodsBarcode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.config,
                                        "showGoodsBarcode",
                                        $$v
                                      )
                                    },
                                    expression: "config.showGoodsBarcode",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "switch-line" },
                              [
                                _c("span", [_vm._v("显示价格")]),
                                _c("el-switch", {
                                  model: {
                                    value: _vm.config.showPrice,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.config, "showPrice", $$v)
                                    },
                                    expression: "config.showPrice",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "switch-line" },
                              [
                                _c("span", [_vm._v("显示数量")]),
                                _c("el-switch", {
                                  model: {
                                    value: _vm.config.showQuantity,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.config, "showQuantity", $$v)
                                    },
                                    expression: "config.showQuantity",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "底部配置", name: "footer" } },
                        [
                          _c(
                            "div",
                            { staticClass: "option-list" },
                            [
                              _c(
                                "div",
                                { staticClass: "switch-line" },
                                [
                                  _c("span", [_vm._v("显示合计金额")]),
                                  _c("el-switch", {
                                    model: {
                                      value: _vm.config.showTotalPrice,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.config,
                                          "showTotalPrice",
                                          $$v
                                        )
                                      },
                                      expression: "config.showTotalPrice",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.config.showTotalPrice
                                ? _c("el-input", {
                                    staticClass: "option-input",
                                    attrs: {
                                      placeholder: "合计标签文字",
                                      size: "small",
                                    },
                                    model: {
                                      value: _vm.config.totalPriceLabel,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.config,
                                          "totalPriceLabel",
                                          $$v
                                        )
                                      },
                                      expression: "config.totalPriceLabel",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "switch-line" },
                                [
                                  _c("span", [_vm._v("显示底部提示")]),
                                  _c("el-switch", {
                                    model: {
                                      value: _vm.config.showTips,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.config, "showTips", $$v)
                                      },
                                      expression: "config.showTips",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.config.showTips
                                ? _c("el-input", {
                                    staticClass: "option-input",
                                    attrs: {
                                      type: "textarea",
                                      rows: 3,
                                      placeholder: "请输入提示文字",
                                      size: "small",
                                    },
                                    model: {
                                      value: _vm.config.tipsText,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.config, "tipsText", $$v)
                                      },
                                      expression: "config.tipsText",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-card",
                {
                  staticClass: "box-card preview-panel",
                  attrs: { shadow: "never" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "preview-header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", { staticClass: "preview-title" }, [
                        _vm._v("实时预览"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "preview-tip" }, [
                        _vm._v("以下为模拟订单数据效果"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("ReceiptPreview", {
                    attrs: {
                      config: _vm.config,
                      data: _vm.mockData,
                      compact: "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }